import { Flex, Text, Box } from '@chakra-ui/react';
import { Icon } from '@chakra-ui/react';
import { useState } from 'react';

const NavItem = ({ icon, label, isActive, onClick }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <Flex
            direction="column"
            align="center"
            justify="center"
            p="3"
            cursor="pointer"
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            position="relative"
            width="100%"
            height="100%"
            borderRadius="18px"
            transition="all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)"
            transform={isHovered ? 'translateY(-2px)' : 'translateY(0px)'}
            _active={{
                transform: 'translateY(0px) scale(0.95)',
                transition: 'all 0.1s ease'
            }}
        >
            {/* Icon container with breath animation */}
            <Box
                position="relative"
                zIndex={2}
                transform={isActive ? "scale(1.1)" : "scale(1)"}
                transition="all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)"
                mb="1"
                animation={isActive ? "breathe 3s ease-in-out infinite" : "none"}
                sx={{
                    '@keyframes breathe': {
                        '0%, 100%': { transform: isActive ? 'scale(1.1)' : 'scale(1)' },
                        '50%': { transform: isActive ? 'scale(1.15)' : 'scale(1.05)' }
                    }
                }}
            >
                <Icon
                    as={icon}
                    boxSize="5"
                    color={isActive ? 'gray.800' : isHovered ? 'gray.700' : 'gray.600'}
                    filter={isActive ? 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1))' : 'none'}
                    transition="all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)"
                />
                
                {/* Icon glow for active state */}
                {isActive && (
                    <Box
                        position="absolute"
                        top="50%"
                        left="50%"
                        transform="translate(-50%, -50%)"
                        width="120%"
                        height="120%"
                        background="radial-gradient(circle, rgba(0, 0, 0, 0.05) 0%, transparent 70%)"
                        borderRadius="50%"
                        pointerEvents="none"
                        animation="iconGlow 2s ease-in-out infinite"
                        sx={{
                            '@keyframes iconGlow': {
                                '0%, 100%': { opacity: 0.3, transform: 'translate(-50%, -50%) scale(1)' },
                                '50%': { opacity: 0.6, transform: 'translate(-50%, -50%) scale(1.2)' }
                            }
                        }}
                    />
                )}
            </Box>

            {/* Label with fade-in animation */}
            <Text 
                fontSize="2xs"
                display={{ base: 'none', sm: 'block' }}
                textAlign="center"
                color={isActive ? 'gray.800' : isHovered ? 'gray.700' : 'gray.600'}
                fontWeight={isActive ? '600' : isHovered ? '500' : '400'}
                transition="all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)"
                whiteSpace="nowrap"
                overflow="hidden"
                textOverflow="ellipsis"
                maxWidth="100%"
                lineHeight="1.2"
                letterSpacing={isActive ? '0.02em' : '0'}
                transform={isHovered ? 'translateY(-1px)' : 'translateY(0px)'}
                textShadow={isActive ? '0 1px 2px rgba(0, 0, 0, 0.1)' : 'none'}
                position="relative"
                zIndex={2}
                py={1}
            >
                {label}
            </Text>

            {/* Ripple effect on click */}
            <Box
                position="absolute"
                top="50%"
                left="50%"
                transform="translate(-50%, -50%)"
                width="0%"
                height="0%"
                bg="rgba(255, 255, 255, 0.2)"
                borderRadius="50%"
                pointerEvents="none"
                zIndex={1}
                className="ripple-effect"
                sx={{
                    '.ripple-effect': {
                        animation: 'none'
                    },
                    '@keyframes ripple': {
                        '0%': { 
                            width: '0%', 
                            height: '0%', 
                            opacity: 0.6 
                        },
                        '100%': { 
                            width: '200%', 
                            height: '200%', 
                            opacity: 0 
                        }
                    }
                }}
            />
        </Flex>
    );
};

export default NavItem;